import React, { useEffect, useMemo, useState } from "react";
import styles from "./Notification.module.scss";
import classNames from "classnames";
import dayjs from "dayjs";
import { TIME_WITH_AM_FORMAT } from "Shared/Constants/app";
import { UrgentIcon } from "Assets";
import { useAppDispatch } from "Redux/store";
import { markAsRead } from "Redux/Notifications/reducer";
import {
  INotification,
  NOTIFICATIONS_PRIORITY,
} from "Shared/Types/notifications";
import { notifyError } from "Components/Notify/notify";
import { useNavigate } from "react-router";
import { NOTIFICATIONS_ROUTE } from "Shared/Constants/notificationsRoute";

type NotificationItemProps = {
  notification: INotification;
  onClose?: () => void;
};

export const NotificationItem = ({
  notification,
  onClose,
}: NotificationItemProps) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [isRead, setIsRead] = useState(notification.is_read);

  const handleMarkAsRead = () => {
    dispatch(
      markAsRead({
        data: notification.id,
        onSuccess: () => {
          setIsRead(true);
          navigate(NOTIFICATIONS_ROUTE[notification.app_name]);
        },
        onError: () => {
          if (onClose) onClose();
          notifyError("Something went wrong please try again later");
        },
      })
    );
  };

  const isUrgent = useMemo(
    () => notification.priority === NOTIFICATIONS_PRIORITY.URGENT,
    [notification.priority]
  );

  useEffect(() => {
    setIsRead(notification.is_read);
  }, [notification.is_read]);

  return (
    <div
      onClick={handleMarkAsRead}
      className={classNames(
        styles.notificationItem,
        isUrgent && styles.notificationItem_urgent,
        isRead && styles.notificationItem_read
      )}
    >
      <div>
        <p>{dayjs(notification.created).format(TIME_WITH_AM_FORMAT)}</p>
        <p>{notification.message}</p>
      </div>

      {isUrgent && (
        <div className={styles.urgent}>
          <UrgentIcon />
          Urgent
        </div>
      )}
    </div>
  );
};
